<div class="modal-header">
    <h3 class="modal-title">
        {{modalTitle}}<i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
        <i class="fa pull-right"
           [class.fa-plus-square-o]="minimise"
           [class.fa-minus-square-o]="!minimise"
           style="margin-right: 10px; cursor: pointer;"
           (click)="minimise=!minimise"></i>
    </h3>
</div>

<div class="modal-body" [hidden]="minimise">
@if (crudLoading) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
@if (!crudLoading) {
<div>
    <form name="screenFrom" id="screenFrom" disabled="disabled" class="form-horizontal" novalidate>
        <div>

            <div style="padding-bottom: 0 !important;">


                @if (!crudLoading) {
<div id="form_header" class="BlackSmHdrBC">
                    {{f8082Header.ATTRIB_DESCRIPTION}}
                </div>
}
                @if (!crudLoading) {
<table class="table table-bordered InnerTblBG">

                    <!---1st loop for whole data --->
                    <tr>
                        <td></td>
                        <td colspan="1">{{ f8082FormData['O'][0].Line_data[1].ATTRIB_DESCRIPTION }}</td>
                        <td colspan="2">
                            <input [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="f8082FormData['O'][0].Line_data[2].ATTRIB_VALUE"
                                class="form-control input-md " type="text"
                                (change)="valuechanged(0, null, f8082FormData['O'][0].Line_data[2].LINE_NO, 2, 'O')"
                                [disabled]="f8082FormData['O'][0].Line_data[2].IS_EDITABLE_CELL==='N'">
                        </td>
                        <td colspan="1">{{ f8082FormData['O'][1].Line_data[1].ATTRIB_DESCRIPTION }}</td>
                        <td colspan="2">
                            <input [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="f8082FormData['O'][1].Line_data[2].ATTRIB_VALUE"
                                class="form-control input-md numText number-field" format="number" only-digits
                                type="text"
                                (change)="valuechanged(1, null, f8082FormData['O'][1].Line_data[2].LINE_NO, 2, 'O')"
                                [disabled]="f8082FormData['O'][1].Line_data[2].IS_EDITABLE_CELL==='N'">
                        </td>
                    </tr>
                    <tr>
                        <th colspan="7">Part I - General Information </th>
                    </tr>

                    @for (row of f8082FormData['P1']; track $index; let $parent = $index) {
<tr class="">
                        <!---inner loop for line data with row_type TH--->

                        @for (item of row.Line_data; track $index) {
<td class=""
                            [hidden]="!(row.ROW_TYPE==='DT') || (row.LINE_NO == '4' && ((isUS && usIndex.includes($parent)) || (!isUS && foreignIndex.includes($parent))))"
                            [attr.colspan]="item.COLSPAN">
                            @if (item.EDIT_TYPE==='textarea' && item.DATA_TYPE==='string' && item.LINE_NO != '4') {
<p>
                                <textarea style="width: 100%" class="form-control input-sm numText"
                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE" placeholder=""
                                    (change)="valuechanged($parent, null, item.LINE_NO, $index, 'P1')">
								</textarea>
                            </p>
}
                            @if (item.EDIT_TYPE==='textarea' && item.DATA_TYPE==='string' && item.LINE_NO == '4') {
<p>
                                <textarea style="width: 100%" class="form-control input-sm numText"
                                    [maxLength]="maxLengthMap[item.LINE_DESCRIPTION]"
                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE" placeholder=""
                                    (change)="valuechanged($parent, null, item.LINE_NO, $index, 'P1')">
								</textarea>
                            </p>
}
                            @if (item.EDIT_TYPE==='currency' && item.DATA_TYPE==='number') {
<p>
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE"
                                    class="form-control input-md numText number-field" format="number" only-digits
                                    type="text" (change)="valuechanged($parent, null, item.LINE_NO, $index, 'P1')"
                                    [disabled]="item.IS_EDITABLE_CELL==='N'">
                            </p>
}
                            @if (item.EDIT_TYPE==='select' && item.DATA_TYPE==='string') {
<p>
                                <ap-dropdown [list]="dropdownOptions" [selectType]="'single'" [title]="'Select'" [inputAriaLabel]="'Select'"
                                    (onSelect)="dropdownSelect($event, $parent, $index)">
                                    @for (item of dropdownOptions; track $index) {
<ap-dropdown-list-item [item]="item" #dropdownListItem [ariaLabel]="setAriaLabel(item, 'Select')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                                </ap-dropdown>
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE"
                                    class="form-control input-md " type="text" disabled [disabled]="true">
                            </p>
}
                            @if (item.EDIT_TYPE==='text' && (item.DATA_TYPE==='string' || item.DATA_TYPE === 'number')) {
<p
                               >
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE"
                                    class="form-control input-md " type="text"
                                    (change)="valuechanged($parent, null, item.LINE_NO, $index, 'P1')"
                                    [disabled]="item.IS_EDITABLE_CELL==='N'">
                            </p>
}
                            @if (item.EDIT_TYPE==='checkbox' && item.DATA_TYPE==='string' && row.Line_data.length == '3') {

                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE"
                                    type="checkbox"
                                    (change)="item.ATTRIB_VALUE = item.ATTRIB_VALUE ? 1 : 0; valuechanged($parent, null, item.LINE_NO, $index, 'P1');">

                                <br />
                            
}
                            @if (item.EDIT_TYPE==='checkbox' && item.DATA_TYPE==='string' && row.Line_data.length == '4') {

                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="item.ATTRIB_VALUE"
                                    type="checkbox"
                                    (change)="item.ATTRIB_VALUE = item.ATTRIB_VALUE ? 1 : 0; checkboxSwitch($parent, $index, item.ATTRIB_VALUE); valuechanged($parent, null, item.LINE_NO, $index, 'P1')">
                                @if ($index == 2) {
<span>Yes</span>
}@if ($index == 3) {
<span>No</span>
}
                                <br />
                            
}
                            @if (row.LINE_NO !=='Header' && item.EDIT_TYPE==='label' && item.DATA_TYPE==='string' && item.ATTRIB_DESCRIPTION != 'N/A' && item.ATTRIB_DESCRIPTION != 'NA') {
<p
                               >
                                @if (row.LINE_NO != '4') {
<span>{{item.ATTRIB_DESCRIPTION}}</span>
}
                                @if (row.LINE_NO == '4' && $index > 0) {
<span>{{ addressMap[item.ATTRIB_DESCRIPTION]
                                    }}</span>
}
                                @if (row.LINE_NO == '4' && $index == 0 && row.Line_data.length == 2) {
<span
                                   >{{item.ATTRIB_DESCRIPTION}}</span>
}


                            </p>
}
                            @if (item.EDIT_TYPE==='custom_date_various' && item.DATA_TYPE==='dateVarious') {
<p>
                                <ap-field [datepicker]="true"
                                    [title]="''"
                                    [hideTitleOnInput]="true"
                                    [editable]="true"
                                    [dpAutoClose]="true"
                                    [dpType]="'single'"
                                    [dpRange]="false"
                                    [dpDateformat]="'MM/dd/yyyy'"
                                    [disabled]="item.IS_EDITABLE_CELL==='N'"
                                    [dpSelectedDates]="item.dateArray"
                                    (dpSelectedDatesChange)="onDateSelected(item, $event, $parent, item.LINE_NO, $index, 'P1')"
                                    class="date-content not-disabled single-date-picker">
                                    <input appkit-field aria-label="Date filed" />
                                </ap-field>
                            </p>
}
                        </td>
}

                    </tr>
}
                </table>
}
                @if (!crudLoading) {
<table class="table table-bordered InnerTblBG" style="display: inline-block;">
                    <tr>
                        <th colspan="8">Part II - Inconsistent or Administrative Adjustment Request (AAR) Items </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        <th colspan="2">(b) Inconsistency is in,
                            or AAR is to correct
                            (check boxes that apply)</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>

                    </tr>
                    <tr>
                        <th></th>
                        <th>(a) Description of inconsistent or AAR items
                            (see instructions) </th>
                        <th>Amount of
                            item</th>
                        <th>Treatment
                            of item </th>
                        <th>(c) Amount as shown on
                            Schedule K-1, Schedule Q, or
                            similar statement; a foreign
                            trust statement; or your return,
                            whichever applies (see
                            instructions) </th>
                        <th>(d) Amount you are reporting</th>
                        <th>(e) Difference between
                            (c) and (d)</th>
                        <th>(f) Explanations—Enter the Part II item number before each explanation. Show how the IU was
                            calculated and how modifications were applied.</th>
                    </tr>
                    @if (showP2) {
<tbody>
                        <tr>
                            <td colspan="8">
                                <i class="fa fa-plus-circle color-green fa-sm pull-left"
                                    style="cursor: pointer; margin-top: 4px;" data-toggle="tooltip"
                                    data-placement="right" data-trigger="hover" (click)="addP2Row()">Add Row</i>
                            </td>
                        </tr>
                        @for (row of f8082FormData['P2'][0].JSON_DATA; track $index; let $parent = $index) {
<tr class="">
                            <!---inner loop for line data with row_type TH--->
                            <td class="">
                                <i class="fa fa-minus-circle color-red fa-sm pull-left"
                                    style="cursor: pointer; margin-top: 4px;" data-toggle="tooltip"
                                    data-placement="right" data-trigger="hover" (click)="deleteP2Row($parent)">{{
                                    $parent + 8 }}</i>
                            </td>
                            <td class="">
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="row.A"
                                    class="form-control input-md " type="text">

                            </td>
                            <td class="">
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="row.B" type="checkbox"
                                    (change)="row.B = row.B ? 1 : 0;">

                                <br />
                            </td>
                            <td class="">
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="row.C" type="checkbox"
                                    (change)="row.C = row.C ? 1 : 0;">

                                <br />
                            </td>
                            <td class="">
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="row.D"
                                    class="form-control input-md numText number-field" format="number" only-digits
                                    type="text" (blur)="updateAmount($parent)">
                            </td>
                            <td class="">
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="row.E"
                                    class="form-control input-md numText number-field" format="number" only-digits
                                    type="text" (blur)="updateAmount($parent)">
                            </td>
                            <td class="">
                                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="row.F"
                                    class="form-control input-md numText number-field" format="number" only-digits
                                    type="text">
                            </td>
                            <td class="">
                                <textarea style="width: 100%;" class="form-control input-sm numText"
                                    [ngModelOptions]="{standalone: true}" [maxLength]="4000" [(ngModel)]="row.G"
                                    placeholder="">
                                </textarea>
                            </td>

                        </tr>
}
                    </tbody>
}

                </table>
}
            </div>
        </div>
    </form>
</div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="crudLoading || isSaveClicked" (click)="save()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
    </button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>